import "countup.js"
import { CountUp } from "countup.js";

$(function() {
    if ($('.hrg-ce-counter').length === 0) return;

    $('.hrg-ce-counter .counter-item').each(function() {
        let $counterValueElement = $(this).find('.counter-value');
        let counterValue = $counterValueElement.data('counter-value');

        const countUp = new CountUp($counterValueElement.get(0), counterValue, {
            decimal: ',',
            separator: '.',
            autoAnimate: true
        });
    });
});
